// extracted by mini-css-extract-plugin
export var circle = "_aa-1";
export var exitConfirmationModal = "_aa-5";
export var iframe = "_aa-0";
export var offline = "_aa-3";
export var online = "_aa-2";
export var workstationSelectError = "_aa-4";